import { call, put, takeLatest } from "redux-saga/effects";
import {
  addAdmissionFailure,
  addAdmissionSuccess,
  deleteAdmissionFailure,
  deleteAdmissionSuccess,
  editAdmissionFailure,
  editAdmissionSuccess,
  fetchAdmissionFailure,
  fetchAdmissionParticularFailure,
  fetchAdmissionParticularSuccess,
  fetchAdmissionPatientFailure,
  fetchAdmissionPatientSuccess,
  fetchAdmissionsByPhoneNumberFailure,
  fetchAdmissionsByPhoneNumberSuccess,
  fetchAdmissionsFailure,
  fetchAdmissionsSuccess,
  fetchAdmissionSuccess,
  fetchAllAdmissionsFailure,
  fetchAllAdmissionsFailures,
  fetchAllAdmissionsSucces,
  fetchAllAdmissionsSuccess,
  fetchReportListFailure,
  fetchReportListSuccess,
  updateAdmissionFailure,
  updateAdmissionSuccess,
  bulkDischargeAdmissionSuccess,
  bulkDischargeAdmissionFailure,
} from "./admissionsActions";
import {
  addAdmissionEffect,
  admissionParticularEffect,
  deleteAdmissionEffect,
  editAdmissionEffect,
  listAdmission,
  listAdmissionAll,
  listAdmissionByPhoneNumber,
  listAdmissionEffect,
  listReportEffect,
  updateAdmissionEffect,
  ViewAdmissionEffect,
  ViewAdmissionPatientEffect,
  bulkDischargeEffect,
} from "./admissionsEffect";
import {
  ADD_ADMISSION_REQUEST,
  DELETE_ADMISSION_REQUEST,
  EDIT_ADMISSION_REQUEST,
  FETCH_ADMISSION_PARTICULAR_REQUEST,
  FETCH_ADMISSION_PATIENT_REQUEST,
  FETCH_ADMISSION_REQUEST,
  FETCH_ADMISSIONS_BY_PHONE_NUMBER_REQUEST,
  FETCH_ALL_LIST_ADMISSIONS_REQUEST,
  FETCH_ALLS_LIST_ADMISSIONS_REQUEST,
  FETCH_LIST_ADMISSIONS_REQUEST,
  FETCH_REPORT_LIST_ADMISSIONS_REQUEST,
  UPDATE_ADMISSION_REQUEST,
  BULK_DISCHARGE_ADMISSION_REQUEST,
} from "./admissionsType";

function* fetchAdmissionsSaga(action) {
  try {
    const response = yield call(listAdmissionEffect, action.payload);
    yield put(fetchAdmissionsSuccess(response.data));
  } catch (error) {
    yield put(fetchAdmissionsFailure(error.message));
  }
}

function* fetchAllAdmissionsSaga(action) {
  try {
    const response = yield call(listAdmission, action.payload);
    yield put(fetchAllAdmissionsSuccess(response.data));
  } catch (error) {
    yield put(fetchAllAdmissionsFailure(error.message));
  }
}

function* fetchAllsAdmissionsSaga(action) {
  try {
    const response = yield call(listAdmissionAll, action.payload);
    yield put(fetchAllAdmissionsSucces(response.data));
  } catch (error) {
    yield put(fetchAllAdmissionsFailures(error.message));
  }
}
function* fetchReportSaga(action) {
  try {
    const response = yield call(listReportEffect, action.payload);
    const Admissions = response.data || response;
    yield put(fetchReportListSuccess(Admissions));
  } catch (error) {
    yield put(fetchReportListFailure(error.message));
  }
}

function* fetchAdmissionSaga(action) {
  try {
    const Admission = yield call(
      ViewAdmissionEffect,
      action.payload.admissionId
    );

    const doctorData = Admission.data || Admission;
    yield put(fetchAdmissionSuccess(doctorData));
  } catch (error) {
    yield put(fetchAdmissionFailure(error.message));
  }
}
function* fetchAdmissionPatientSaga(action) {
  try {
    const Admission = yield call(
      ViewAdmissionPatientEffect,
      action.payload.admissionId
    );

    const doctorData = Admission.data || Admission;
    yield put(fetchAdmissionPatientSuccess(doctorData));
  } catch (error) {
    yield put(fetchAdmissionPatientFailure(error.message));
  }
}
function* addAdmissionSaga(action) {
  try {
    const response = yield call(
      addAdmissionEffect,
      action?.payload?.admissionData
    );
    yield put(addAdmissionSuccess(response.data));
  } catch (error) {
    yield put(addAdmissionFailure(error.message));
  }
}

function* updateAdmissionSaga(action) {
  try {
    const admissionData = action.payload;
    const response = yield call(
      editAdmissionEffect,
      admissionData.admissionId,
      admissionData
    );
    yield put(updateAdmissionSuccess(response.data));
  } catch (error) {
    yield put(updateAdmissionFailure(error.message));
  }
}

function* deleteAdmissionSaga(action) {
  try {
    yield call(deleteAdmissionEffect, action.payload.admissionId);
    yield put(deleteAdmissionSuccess(action.payload.AdmissionId));
  } catch (error) {
    yield put(deleteAdmissionFailure(error.message));
  }
}
function* fetchAdmissionsByPhoneNumberSaga(action) {
  try {
    const response = yield call(
      listAdmissionByPhoneNumber,
      action.payload.phoneNumber
    );
    yield put(fetchAdmissionsByPhoneNumberSuccess(response.data));
  } catch (error) {
    yield put(fetchAdmissionsByPhoneNumberFailure(error.message));
  }
}

function* editAdmissionSaga(action) {
  const {admissionData ,admissionId } = action.payload;
  try {
    const response = yield call(
      updateAdmissionEffect,
      admissionId,
      admissionData
    );
    yield put(editAdmissionSuccess(response.data));
  } catch (error) {
    yield put(editAdmissionFailure(error.message));
  }
}

function* fetchAdmissionParticularSaga(action) {
  try {
    const { admissionId } = action.payload;
    const response = yield call(admissionParticularEffect, admissionId);
    yield put(fetchAdmissionParticularSuccess(response.data));
  } catch (error) {
    yield put(fetchAdmissionParticularFailure(error.message));
  }
}

function* bulkDischargeAdmissionSaga(action) {
  try {
    const response = yield call(bulkDischargeEffect, action.payload.data);
    yield put(bulkDischargeAdmissionSuccess(response.data));
  } catch (error) {
    yield put(bulkDischargeAdmissionFailure(error.message));
  }
}

export function* AdmissionSagas() {
  yield takeLatest(FETCH_LIST_ADMISSIONS_REQUEST, fetchAdmissionsSaga);
  yield takeLatest(FETCH_ADMISSION_REQUEST, fetchAdmissionSaga);
  yield takeLatest(ADD_ADMISSION_REQUEST, addAdmissionSaga);
  yield takeLatest(UPDATE_ADMISSION_REQUEST, updateAdmissionSaga);
  yield takeLatest(DELETE_ADMISSION_REQUEST, deleteAdmissionSaga);
  yield takeLatest(FETCH_ADMISSION_PATIENT_REQUEST, fetchAdmissionPatientSaga);
  yield takeLatest(FETCH_REPORT_LIST_ADMISSIONS_REQUEST, fetchReportSaga);
  yield takeLatest(FETCH_ALL_LIST_ADMISSIONS_REQUEST, fetchAllAdmissionsSaga);
  yield takeLatest(FETCH_ALLS_LIST_ADMISSIONS_REQUEST, fetchAllsAdmissionsSaga);
  yield takeLatest(FETCH_ADMISSIONS_BY_PHONE_NUMBER_REQUEST, fetchAdmissionsByPhoneNumberSaga);
  yield takeLatest(EDIT_ADMISSION_REQUEST, editAdmissionSaga);
  yield takeLatest(FETCH_ADMISSION_PARTICULAR_REQUEST, fetchAdmissionParticularSaga);
  yield takeLatest(BULK_DISCHARGE_ADMISSION_REQUEST, bulkDischargeAdmissionSaga);
}
